export default {
  title: 'Crea nuova password',
  description: 'Crea una nuova password per il tuo account.',
  form: {
    new_password: {
      label: 'Nuova password',
      placeholder: 'Inserisci password',
      requirements: 'La password deve contenere 8 caratteri, una lettera maiuscola e un numero',
    },
    confirm_password: {
      label: 'Conferma nuova password',
      placeholder: 'Conferma password',
    },
    error_messages: {
      missing_info: 'Informazioni mancanti',
    },
  },
  buttons: {
    update_password: 'Aggiorna password',
  },
};
